module.exports = __webpack_public_path__ + "img/icon_excel_active.b4c7f834.svg";